import {
  USR_LOGIN_COMPLETE,
  USR_LOGOUT_COMPLETE,
  USR_CARGANDO_COMPLETE,
  USR_ERROR_COMPLETE,
} from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  cargando: false,
  error: "",
  isLogged: false,
  id: 0,
  usuario: "",
  nombre: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USR_ERROR_COMPLETE:
      return { ...state, error: get(action, "payload") };
    case USR_LOGIN_COMPLETE:
      var usr2 = get(action, "payload");
      return {
        ...state,
        isLogged: true,
        id: usr2.ID_USUARIO,
        usuario: usr2.USER,
        nombre: usr2.NOMBRE,
      };
    case USR_LOGOUT_COMPLETE:
      return { ...state, isLogged: false, usuario: "", id: 0, nombre: "" };
    case USR_CARGANDO_COMPLETE:
      return { ...state, cargando: get(action, "payload") };
    default:
      return { ...state };
  }
}
